import axios from 'axios';

const BASE_URL = '/app/wordPressFunnel';

export const loadWordPressList = async () => {
    const { data } = await axios.get(`${BASE_URL}/optinList`);

    return data;
};
